import * as THREE from 'three';
import Application from '../Application';
import AudioManager from '../Audio/AudioManager';
import ComputerSetup from './Computer';
import Decor from './Decor';
import Environment from './Environment';
import MonitorScreen from './MonitorScreen';
export default class World {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        // Setup dark ambient lighting
        this.ambientLight = new THREE.AmbientLight(0x404040, 0.1); // Very dim ambient light
        this.scene.add(this.ambientLight);
        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.environment = new Environment();
            this.decor = new Decor();
            this.computerSetup = new ComputerSetup();
            this.monitorScreen = new MonitorScreen();
            this.audioManager = new AudioManager();
            // const hb = new Hitboxes();
            // this.cursor = new Cursor();
        });
    }
    update() {
        if (this.monitorScreen)
            this.monitorScreen.update();
        if (this.environment)
            this.environment.update();
        if (this.audioManager)
            this.audioManager.update();
    }
}
